import { css, etiColors } from '@eti/styles';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const stairStyles = css`
  fill: ${etiColors.grayScale[10]};
  ${rowItemSize};
`;
const Stairs = () => /*#__PURE__*/_jsx("svg", {
  className: stairStyles,
  "data-testid": "stairs",
  viewBox: "0 0 64 64",
  children: /*#__PURE__*/_jsx("path", {
    d: "M59.73 0H4.27A4.27 4.27 0 0 0 0 4.27v55.46A4.27 4.27 0 0 0 4.27 64h55.46A4.27 4.27 0 0 0 64 59.73V4.27A4.27 4.27 0 0 0 59.73 0zm0 14.933h-12.8v12.8h-12.8v12.8h-12.8v12.8H4.267v-4.266h12.8v-12.8h12.8v-12.8h12.8v-12.8h17.066z"
  })
});
export default Stairs;
//# sourceMappingURL=Stairs.js.map